import * as React from "react";
import { Query, QueryCondition, AuditTrailEntity } from "../../misc/api/apiTypes";
import { getQueryFilters } from "../../misc/components/queryTable/ReducerUtilities";
import MultiSelectModal from "../../misc/components/queryTable/MultiSelectModal";
import uniqBy from "lodash-es/uniqBy";
import { GetFilterValues } from "../../misc/components/queryTable/FilterValuesSelector";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export interface ActionFilterProps {
    analysisSetOldId: number;
    auditQuery: Query<AuditTrailEntity>;
    isActionFilterVisible: boolean;
    onChange: (auditQuery: Query<AuditTrailEntity>) => Promise<void>;
    onClose: () => void;
    filterableEntityTypes: string[];
}

export interface ActionFilterState {
    actionTypesQuery: Query<AuditTrailEntity>;
}

export const ActionFilter = (props: ActionFilterProps) => {
    const ActionNameQueryMember: "Event.ActionName" = "Event.ActionName";
    const TypeNameQueryMember: "TypeName" = "TypeName";

    const [actionTypesQuery, setActionTypesQuery] = React.useState<Query<AuditTrailEntity>>({
        Data: [],
        Members: [ActionNameQueryMember],
        Filters: [{ Member: TypeNameQueryMember, Values: props.filterableEntityTypes }]
    })

    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getActionTypes = async () => {
            await fetchActionTypes(actionTypesQuery);
        }

        getActionTypes();
    }, [actionTypesQuery.Filters]);

    const onActionChange = async e => {
        const filters = getQueryFilters(
            props.auditQuery,
            ActionNameQueryMember,
            QueryCondition.Equal,
            e
        );

        const eventsQuery: Query<AuditTrailEntity> = {
            ...props.auditQuery,
            Filters: filters
        };

        await props.onChange(eventsQuery);
    };

    const fetchActionTypes = async (actionTypeQuery: Query<AuditTrailEntity>) => {
        const filters = getQueryFilters(
            actionTypesQuery,
            "RecordId",
            QueryCondition.Equal,
            props.analysisSetOldId
        )

        actionTypeQuery = {
            ...actionTypesQuery,
            Filters: [...filters, ...actionTypeQuery.Filters],
        };

        const actionTypesQueryResult = await legacyClient.getAnalysisSetAuditEntities(actionTypeQuery);

        setActionTypesQuery(actionTypesQueryResult);
    }

    return (
        <ErrorBoundary>
            <MultiSelectModal
                header="Action Filter"
                show={props.isActionFilterVisible}
                options={
                    actionTypesQuery
                        ? uniqBy(actionTypesQuery.Data, x => x.ActionName)
                        : []
                }
                valueKey="ActionName"
                labelKey="ActionName"
                values={GetFilterValues(
                    "Event.ActionName",
                    QueryCondition.Equal,
                    props.auditQuery
                )}
                onChange={e => onActionChange(e.map(v => v.ActionName))}
                onClose={() => props.onClose()}
            />
        </ErrorBoundary>
    );
}
